import type { PageContext } from 'vike/types';
import { LOCALIZED_PATHS } from '../../utils/constants/url-constants';

const LOCALES = ['en', 'fi', 'sv'] as const;

/**
 * Roles index: `/en/jobs/roles`, `/fi/tyopaikat/ammatit`, `/sv/lediga-jobb/yrken` (logical
 * `/jobs/roles`). A route function because the page sits under the jobs segment, which the SRP
 * catch-all (pages/index) owns; that matcher rejects this path (unknown trailing segment) so the
 * two never both match.
 */
export function route(pageContext: PageContext) {
  const raw = ((pageContext as { urlLogical?: string }).urlLogical ?? pageContext.urlPathname ?? '').split('?')[0].replace(/\/+$/, '');
  if (raw === '/jobs/roles') return { routeParams: { locale: 'en' } };
  const parts = raw.split('/').filter(Boolean);
  if (parts.length !== 3) return false;
  const [locale, jobs, index] = parts;
  if (!(LOCALES as readonly string[]).includes(locale)) return false;
  const paths = LOCALIZED_PATHS[locale as (typeof LOCALES)[number]];
  if (jobs !== paths.jobs || index !== paths.rolesIndex) return false;
  return { routeParams: { locale } };
}
